import React from 'react';
import { Icons, Tooltip } from '@nextiva/next-ui-components';
import { formattedLicensePricingDataType } from 'types/purchaseLicenseModalTypes';
import {
  StyledPaymentContainer,
  StyledPaymentText,
  StyledCreditCardContainer,
  StyledCreditCardText,
  StyledPaymentIcon,
  StyledHelpIcon,
  StyledExpiredText,
} from './CreditCardInfo.styles';

const EXPIRED_TEXT = 'Your card expired';

interface ICreditCardInfo {
  isPaymentExpired: boolean;
  formattedLicensePricingData: formattedLicensePricingDataType;
  didInitialLicensePricingDataApiCallFail: boolean;
  defaultPaymentMethodDoesNotExist: boolean;
}

export const CreditCardInfo = ({
  isPaymentExpired,
  formattedLicensePricingData,
  didInitialLicensePricingDataApiCallFail,
  defaultPaymentMethodDoesNotExist,
}: ICreditCardInfo) => {
  const isPaymentMethodECheck =
    formattedLicensePricingData?.paymentMethod === 'ECHECK';
  const formattedCreditCardText = formattedLicensePricingData?.lastFourDigitsOfPaymentMethod
    ? `Card ending in ${formattedLicensePricingData.lastFourDigitsOfPaymentMethod}`
    : 'Card';
  const formattedEcheckText = formattedLicensePricingData?.eCheckSuffix
    ? `eCheck ending in ${formattedLicensePricingData.eCheckSuffix}`
    : 'eCheck';
  const formattedPaymentText = isPaymentMethodECheck
    ? formattedEcheckText
    : formattedCreditCardText;
  const TOOLTIP_TEXT = defaultPaymentMethodDoesNotExist
    ? 'Your payment method is located in the billing section under Payment.'
    : 'Want a different way to pay? Visit Billing section and look under Payment.';

  return (
    <StyledPaymentContainer>
      <StyledPaymentText>Payment</StyledPaymentText>
      {didInitialLicensePricingDataApiCallFail ? (
        <StyledCreditCardText>--</StyledCreditCardText>
      ) : (
        <>
          <StyledCreditCardContainer>
            <StyledPaymentIcon
              icon={isPaymentMethodECheck ? Icons.moneyCheck : Icons.creditCard}
            />
            <StyledCreditCardText>
              {defaultPaymentMethodDoesNotExist ? '--' : formattedPaymentText}
            </StyledCreditCardText>
            <Tooltip placement="top" title={TOOLTIP_TEXT}>
              <StyledHelpIcon
                icon={Icons.help}
                aria-label="Help"
                data-testid="PlatformAdminUI-PurchaseLicenseModal-CreditCardHelpIcon"
              />
            </Tooltip>
          </StyledCreditCardContainer>
          {isPaymentExpired && (
            <StyledExpiredText variant="caption">
              {EXPIRED_TEXT}
            </StyledExpiredText>
          )}
        </>
      )}
    </StyledPaymentContainer>
  );
};
